// JSON-LD builders (schema.org). Only facts that are shown on the site itself.
const SITE = (process.env.REACT_APP_PUBLIC_SITE_URL || "").replace(/\/$/, "");
const abs = (path) => (path?.startsWith("http") ? path : `${SITE}${path || ""}`);

export const ORG = { "@type": "Organization", "@id": `${SITE}/#org`, name: "First Mover OS", url: `${SITE}/`, logo: abs("/favicon.svg") };

const graph = (...nodes) => ({ "@context": "https://schema.org", "@graph": nodes });

export const breadcrumbs = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: [["Home", "/"], ...items].map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: abs(path) })),
});

export const homeSchema = (description) => graph(
  ORG,
  { "@type": "WebSite", "@id": `${SITE}/#website`, name: "First Mover OS", url: `${SITE}/`, description, publisher: { "@id": `${SITE}/#org` } },
);

export const pageSchema = (type, name, path, description, extra = {}) => graph(
  ORG,
  { "@type": type, name, url: abs(path), description, isPartOf: { "@id": `${SITE}/#website` }, ...extra },
  breadcrumbs([[name, path]]),
);

export const productSchema = (p) => graph(
  ORG,
  {
    "@type": "Product",
    name: p.name,
    description: p.tagline,
    image: abs(p.image),
    url: abs(`/products/${p.role}`),
    brand: { "@id": `${SITE}/#org` },
    offers: {
      "@type": "Offer",
      price: Number(p.price).toFixed(2),
      priceCurrency: p.currency || "CHF",
      availability: "https://schema.org/InStock",
      url: abs(`/products/${p.role}`),
      seller: { "@id": `${SITE}/#org` },
    },
  },
  breadcrumbs([["Products", "/products"], [p.name, `/products/${p.role}`]]),
);

export const faqSchema = (faqs, name, path, description) => graph(
  ORG,
  {
    "@type": "FAQPage",
    name,
    url: abs(path),
    description,
    mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
  },
  breadcrumbs([[name, path]]),
);

export const articleSchema = (a) => graph(
  ORG,
  {
    "@type": "BlogPosting",
    headline: a.title,
    description: a.meta_description || a.subtitle,
    image: a.image_url || undefined,
    datePublished: a.published_at || undefined,
    dateModified: a.updated_at || undefined,
    author: a.author_name ? { "@type": "Person", name: a.author_name } : undefined,
    publisher: { "@id": `${SITE}/#org` },
    mainEntityOfPage: abs(`/blog/${a.slug}`),
    inLanguage: a.language_code || undefined,
  },
  breadcrumbs([["Blog", "/blog"], [a.title, `/blog/${a.slug}`]]),
);
